<template>
  <div>
    <button
      :class="buttonClass"
      @click="emitOpen()"
    >
      <slot>{{ trans.get('profile:modal.report_profile.report_modal_show_button') }}</slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ReportModalButton',
  props: {
    profileId: {
      required: true,
    },
    buttonClass: {
      required: false,
      type: String,
      default: 'button button__link button__link--underline',
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    emitOpen() {
      this.$eventHub.$emit('ReportModalOpen', this.profileId);
    },
  },
  mounted() {
  }
};
</script>

<style scoped>

</style>
